"use client";
import InboxTabs, { TabList } from "@/app/shared/support/inbox/inbox-tabs";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import useFetch from "@/hooks/fetch/useFetch";
import getData from "@/functions/getData";
import { Axios } from "axios";
import { apis } from "@/static/apis/apis";
import Spinner from "@/components/ui/spinner";
import { Chatroom } from "@/types/chatroom/chatroom";
import { useRouter } from "next/navigation";
import { Stepper, Step, Button } from "rizzui";
import { CiCreditCard1 } from "react-icons/ci";
import { TbCurrencyIranianRial } from "react-icons/tb";
import { FaRegSmileWink } from "react-icons/fa";
import { Title, Text } from "@/components/ui/text";
import { TbExclamationMark } from "react-icons/tb";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import { StateEveryType } from "@/types/global";
import { ChatRoomType } from "@/types/requests/ChatRoom";
import MessageList from "../inbox/message-list";
import cn from "@/utils/class-names";
import postData from "@/functions/postData";

export default function HelpInbox() {
  const router = useRouter();
  const [id, setId] = useState(-1);
  const [option, setOption] = useState([false, false, false, false]);
  const axios = useAxiosAuth();
  const handelClick = (indexInput: number) => {
    setOption((x) => {
      return x.map((element, index) => {
        return index === indexInput ? true : false;
      });
    });
  };
  const [chatRooms, setChatRooms] = useState();
  const { data: session } = useSession();
  let admin = session?.user.user_permissions.chatroom_watcher;
  const [chatData, setChatData] = useFetch(
    (axios: Axios, setData: Dispatch<any>) => {
      if (id >= 0)
        getData(
          admin ? apis.chatroom.adminShow(id) : apis.chatroom.show(id),
          axios,
          setData
        );
    },
    undefined,
    undefined,
    undefined,
    id
  ) as [
    messages: StateEveryType<ChatRoomType>,
    setMessage: Dispatch<SetStateAction<StateEveryType<ChatRoomType>>>,
  ];
  // const [chatData, setChatData] = useFetch((axios:Axios))
  return (
    <>
      <div className="@container">
        <div className="mt-5  @container @2xl:mt-9 @4xl:grid @4xl:grid-cols-12 @4xl:gap-7 @[1550px]:grid-cols-11">
          <div className="@xs:col-span-12 @4xl:col-span-4 @[1550px]:col-span-3">
            <MessageList
              id={id}
              setId={setId}
              className="@xs:col-span-12 @4xl:col-span-4 @[1550px]:col-span-3"
            ></MessageList>
          </div>
          {id < 0 ? (
            <></>
          ) : chatData.loading ? (
            <div className=" @4xl:col-start-3 @4xl:col-end-11 @4xl:block @[1550px]:col-start-3 @[1550px]:col-end-11">
              <Spinner size="xl" />
            </div>
          ) : (
            <>
              <InboxTabs
                className={
                  " @4xl:col-span-8 @4xl:block @[1550px]:col-span-8 sticky top-24 " +
                  (id < 0 ? " bg-red-300" : "")
                }
                id={id}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}
